import React, { FC, ReactNode } from 'react';
import BannerThemes from './BannerThemes';
import { Button, ButtonProps, ButtonStyles, Icon, IconProps, Icons } from '@silverfort/sf-components';

interface BannerProps {
    theme?: keyof typeof BannerThemes;
    children: ReactNode;
    onClose?: () => void;
    hideIcon?: boolean;
    actionButtonProps?: ButtonProps;
    iconProps?: IconProps;
    className?: string;
    sx?: { root: React.CSSProperties };
}

interface BannerBodyProps {
    title?: ReactNode | string;
    content: ReactNode | string;
}

const calcIcon = (iconProps?: IconProps, theme?: keyof typeof BannerThemes, hideIcon?: boolean) => {
    if (hideIcon) return <></>;
    if (theme) {
        const icon = BannerThemes[theme]?.icon;

        if (!icon) {
            console.warn(`No icon found for theme: ${theme}`);
            return <></>;
        }

        return React.cloneElement(icon, { ...iconProps });
    } else if (iconProps) {
        return <Icon {...iconProps} />;
    }
    return <></>;
};

const BannerBody: FC<BannerBodyProps> = ({ title, content }) => (
    <div className="flex flex-1 gap-1 font-sf text-13 text-sf-gray-800">
        <div>
            {title && <div className="font-medium">{title}</div>}
            <div>{content}</div>
        </div>
    </div>
);

export const Banner: FC<BannerProps> & { Body: FC<BannerBodyProps> } = ({
    theme,
    children,
    onClose,
    hideIcon,
    iconProps,
    className,
    sx,
    actionButtonProps
}) => (
    <div
        className={`w-full p-4 flex  gap-4 ${
            theme && BannerThemes[theme] ? BannerThemes[theme].className : ''
        } ${className}`}
        style={sx?.root}>
        <div className="flex flex-1 items-center">
            <div className="h-fit flex flex-1 gap-3">
                <div className="pt-[1px]">{calcIcon(iconProps, theme, hideIcon)}</div>
                {children}
            </div>
        </div>
        {actionButtonProps && (
            <div className="flex items-center">
                <Button buttonStyle={ButtonStyles.Action} {...actionButtonProps} />
            </div>
        )}
        {onClose && <Icon icon={Icons.Cancel} onClick={onClose} className="text-sf-gray-400 w-4 h-4 cursor-pointer" />}
    </div>
);

Banner.Body = BannerBody;

export default Banner;
